export const GET_ALL_SHIPPING_CHARGE_REQUEST = "GET_ALL_SHIPPING_CHARGE_REQUEST";
export const GET_ALL_SHIPPING_CHARGE_FAILURE = "GET_ALL_SHIPPING_CHARGE_FAILURE";
export const GET_ALL_SHIPPING_CHARGE_SUCCESS = "GET_ALL_SHIPPING_CHARGE_SUCCESS";

export const CREATE_SHIPPING_CHARGE_REQUEST = "CREATE_SHIPPING_CHARGE_REQUEST";
export const CREATE_SHIPPING_CHARGE_FAILURE = "CREATE_SHIPPING_CHARGE_FAILURE";
export const CREATE_SHIPPING_CHARGE_SUCCESS = "CREATE_SHIPPING_CHARGE_SUCCESS";

export const UPDATE_SHIPPING_CHARGE_REQUEST = "UPDATE_SHIPPING_CHARGE_REQUEST";
export const UPDATE_SHIPPING_CHARGE_FAILURE = "UPDATE_SHIPPING_CHARGE_FAILURE";
export const UPDATE_SHIPPING_CHARGE_SUCCESS = "UPDATE_SHIPPING_CHARGE_SUCCESS";

export const DELETE_SHIPPING_CHARGE_REQUEST = "DELETE_SHIPPING_CHARGE_REQUEST";
export const DELETE_SHIPPING_CHARGE_FAILURE = "DELETE_SHIPPING_CHARGE_FAILURE";
export const DELETE_SHIPPING_CHARGE_SUCCESS = "DELETE_SHIPPING_CHARGE_SUCCESS";